
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { assignUserCarBookingSiteRecord } from "redux/authorization/userSlice";
import { useDispatch } from "react-redux";
import React, { useEffect, useMemo, useState } from "react";
import Select from 'react-select';
import PropTypes from 'prop-types';
import { FaInfoCircle, FaCar } from "react-icons/fa";
import { selectIconComponents, reactSelectCompactStyles } from 'helpers/reactSelectIconControl';

// Stable reference — see note in AssignRole; inline components break the menu.
const CAR_SITE_SELECT_COMPONENTS = selectIconComponents(<FaCar size={14} className="tw-text-sky-500" />);

const RecordLevelCarBookingSite = ({userId, data=[], sites=[]}) => {
  const { handleSubmit, setValue } = useForm();
  const [selectedSites, setSelectedSites] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    const selected = data.length > 0 && data.map(item => ({value: item.id, label: item.name}));
    setSelectedSites(selected);
  }, [userId, data, sites])

  const onSubmit = (data) => {

    try {
      if (userId) {
        dispatch(assignUserCarBookingSiteRecord({userId, data}))
      }
    }
    catch (error) {
      toast.error(error.message)
    }
  }
  
  const siteOptions = sites && sites.map(item => ({value: item.id, label: item.name}));

  const defaultSiteOption = useMemo(() => {
    if (data) {
      return data.map((item) => ({value: item.id, label: item.name}));
    }
    return null;
  }, [data]);

  const handleChangeSalesUnit = (selectedOptions) => {
    const selectedOptionsValues = selectedOptions.map((option) => option.value);
    setValue('site_ids', selectedOptionsValues, { shouldValidate: true })
    setSelectedSites(selectedOptions)
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="tw-mb-2 tw-text-xs">
          <Select
            components={CAR_SITE_SELECT_COMPONENTS}
            styles={reactSelectCompactStyles}
            closeMenuOnSelect={false}
            options={siteOptions}
            defaultValue={defaultSiteOption}
            value={selectedSites}
            placeholder='Select...'
            classNamePrefix='react-select'
            isMulti
            onChange={handleChangeSalesUnit}
          />
        </div>

        <div className="tw-flex tw-justify-end tw-mt-2">
          <button type="submit" className="tw-inline-flex tw-items-center tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-rounded-md tw-border tw-border-gray-300 tw-bg-white hover:tw-bg-gray-50 tw-text-gray-700 tw-cursor-pointer tw-transition-colors">
            {data.length > 0 ? "Update" : "Add"} Site
          </button>
        </div>
      </form>

      <div className="tw-mt-4 tw-text-xs"><FaInfoCircle /> Assigning Site for limit record access to Car booking.</div>
    </>
  )
};

RecordLevelCarBookingSite.propTypes = {
  userId: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired
}

export default RecordLevelCarBookingSite;